import React, { useMemo, useState } from "react";
import { ProductDetailsModal } from "../../../../interfaces/ProductObject";
import { productImageUrls } from "../../../../services/helpers/ProductImageHelper";
import ProductCardHelper from "../../../../services/helpers/ProductCardHelper";
import { Assets } from "../../../../constants/Assets";
import "./styles/DineInProductThumb.css";

interface DineInProductThumbProps {
  product?: ProductDetailsModal;
}

/**
 * Minimal image-with-fallback thumbnail for a dine-in feed row. Reuses the
 * app's single source of truth for product media (productImageUrls,
 * productMediaResources-only, no legacy guessing) but NOT the full
 * <ProductImage> component — its CSS hard-sizes to a 220-300px grid card
 * (ProductCard.css), which isn't a fit for a small row thumbnail. One image
 * URL attempt, falls back to the shared product-fallback image on error —
 * no multi-candidate retry, this is a low-stakes 52px thumbnail.
 */
const DineInProductThumb: React.FC<DineInProductThumbProps> = ({ product }) => {
  const imageUrl = useMemo(() => {
    if (!product) return undefined;
    return productImageUrls(ProductCardHelper.retrieveProductCard(product))[0];
  }, [product]);

  const [failed, setFailed] = useState(false);

  return (
    <img
      className="dine-in-product-thumb"
      src={!imageUrl || failed ? Assets.PLACEHOLDERS.PRODUCT_IMAGE : imageUrl}
      alt={product?.title ?? "Menu item"}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

export default DineInProductThumb;
